module.exports = __webpack_public_path__ + "bedroom-quilt3.fedbe836.png";